export default class RequestQueue {
    private eternalCurrentIndex: number = 0
    private eternal: Function[] = [];
    private queue: Function[] = [];

    constructor() {
        setInterval(() => {
            if (this.queue.length) {
                const fn = this.queue.shift();
                if (typeof fn === 'function') {
                    fn();
                }
            } else {
                if (this.eternal.length === this.eternalCurrentIndex) {
                    this.eternalCurrentIndex = 0;
                }
                const fn = this.eternal[this.eternalCurrentIndex];
                if (typeof fn === 'function') {
                    fn();
                }
                this.eternalCurrentIndex++;
            }
        }, 60000)
    }

    addToEternal(item: Function): void {
        this.eternal.push(item);
    }

    addToQueue(item: Function): void {
        this.queue.push(item);
    }
}